(() => {
  if (window.capillusDiscountNinjaBadgeSyncReady) return;
  window.capillusDiscountNinjaBadgeSyncReady = true;

  let scheduled = false;
  let syncing = false;
  const mirrorClass = 'capillus-discount-ninja-badge-pill';
  const originalPriceMarkup = new WeakMap();

  const ensureMirrorStyles = () => {
    if (document.getElementById('CapillusDiscountNinjaBadgeMirrorStyles')) return;

    const styles = document.createElement('style');
    styles.id = 'CapillusDiscountNinjaBadgeMirrorStyles';
    styles.textContent = `
      .${mirrorClass} {
        position: absolute !important;
        inset: 12px 12px auto auto !important;
        z-index: 3 !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: auto !important;
        height: auto !important;
        min-width: 0 !important;
        min-height: 28px !important;
        margin: 0 !important;
        padding: 6px 10px !important;
        box-sizing: border-box !important;
        color: #fff !important;
        background: #e71949 !important;
        border: 0 !important;
        border-radius: 14px !important;
        box-shadow: none !important;
        transform: none !important;
        font-family: var(--font-body-family) !important;
        font-size: 12px !important;
        font-weight: 700 !important;
        line-height: 1 !important;
        white-space: nowrap !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(styles);
  };

  const normalizeMirroredBadge = (badge) => {
    const badgeText = badge.textContent.replace(/\s+/g, ' ').trim();
    if (!badgeText) return;

    badge.className = `limoniapps-discountninja-badge ${mirrorClass}`;
    badge.removeAttribute('style');
    badge.textContent = badgeText;
  };

  const findSourceBadge = (cards) => {
    const originalBadge = cards
      .map((card) => card.querySelector(
        '.limoniapps-discountninja-badge:not([data-capillus-dn-mirror]):not([data-utm-dn-mirror])'
      ))
      .find(Boolean);

    return originalBadge || cards
      .map((card) => card.querySelector('.limoniapps-discountninja-badge'))
      .find(Boolean);
  };

  const findSourcePrice = (cards) => cards
    .map((card) => {
      const price = card.querySelector('[data-la-dn-price]');
      const nativeReplacement = price?.querySelector(
        '.limoniapps-discountninja-productprice-replaced:not([data-capillus-dn-price-mirror])'
      );
      return nativeReplacement ? price : null;
    })
    .find(Boolean);

  const getPriceContainer = (card) => card.querySelector(
    '[data-la-dn-price], [data-capillus-dn-price-mirror-container]'
  );

  const getOriginalPriceMarkup = (price) => {
    const nativeOriginal = Array.from(price.children).find((child) => (
      child.classList.contains('limoniapps-discountninja-productprice-original')
    ));
    return nativeOriginal ? nativeOriginal.innerHTML : price.innerHTML;
  };

  const mirroredPriceMarkup = (sourcePrice) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = sourcePrice.innerHTML;
    wrapper.querySelector('.limoniapps-discountninja-productprice-replaced')
      ?.setAttribute('data-capillus-dn-price-mirror', 'true');
    return wrapper.innerHTML;
  };

  const syncPrices = (cards) => {
    const sourcePrice = findSourcePrice(cards);

    cards.forEach((card) => {
      const targetPrice = getPriceContainer(card);
      if (!targetPrice || targetPrice === sourcePrice) return;

      const mirroredRoot = targetPrice.querySelector('[data-capillus-dn-price-mirror]');

      if (!sourcePrice) {
        if (mirroredRoot && originalPriceMarkup.has(targetPrice)) {
          targetPrice.innerHTML = originalPriceMarkup.get(targetPrice);
          targetPrice.setAttribute('data-la-dn-price', '');
          targetPrice.removeAttribute('data-capillus-dn-price-mirror-container');
        }
        return;
      }

      if (!originalPriceMarkup.has(targetPrice)) {
        originalPriceMarkup.set(targetPrice, getOriginalPriceMarkup(targetPrice));
      }

      const nextMarkup = mirroredPriceMarkup(sourcePrice);
      if (targetPrice.innerHTML !== nextMarkup) {
        targetPrice.innerHTML = nextMarkup;
      }
      targetPrice.removeAttribute('data-la-dn-price');
      targetPrice.setAttribute('data-capillus-dn-price-mirror-container', 'true');
    });
  };

  const insertBadge = (target, badge) => {
    if (target.tagName === 'IMG') {
      target.insertAdjacentElement('afterend', badge);
    } else {
      target.appendChild(badge);
    }
  };

  const syncBadges = () => {
    scheduled = false;
    if (syncing) return;
    syncing = true;

    const groups = new Map();

    document.querySelectorAll('[data-la-dn-product-id]').forEach((card) => {
      const productId = card.dataset.laDnProductId;
      if (!productId) return;
      if (!groups.has(productId)) groups.set(productId, []);
      groups.get(productId).push(card);
    });

    groups.forEach((cards) => {
      if (cards.length < 2) return;

      syncPrices(cards);

      const sourceBadge = findSourceBadge(cards);
      if (!sourceBadge) return;

      cards.forEach((card) => {
        const existingBadge = card.querySelector('.limoniapps-discountninja-badge');
        if (existingBadge) {
          if (existingBadge.hasAttribute('data-capillus-dn-mirror')) {
            normalizeMirroredBadge(existingBadge);
          }
          return;
        }

        const target = card.querySelector('.la-dn-collection-badge');
        if (!target) return;

        const mirroredBadge = sourceBadge.cloneNode(true);
        mirroredBadge.dataset.capillusDnMirror = 'true';
        normalizeMirroredBadge(mirroredBadge);
        insertBadge(target, mirroredBadge);
      });
    });

    syncing = false;
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(syncBadges);
  };

  const start = () => {
    ensureMirrorStyles();
    scheduleSync();

    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', scheduleSync);
    document.addEventListener('la:dn:collection:updated', scheduleSync);
    window.addEventListener('load', scheduleSync, { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
